export const COLOR_PRIMARY_BG = "#1A1D38";
export const COLOR_PRIMARY_ORANGE = "#E75012"
export const COLOR_SECONDARY_BLUE = "#283583"